module.exports = __webpack_public_path__ + "static/media/main4.70fea1f0.jpg";